import { useApolloClient } from "@apollo/client"
import { useMutation } from "@tanstack/react-query"

import { useTRPC } from "lib/trpc"

const toastMessages = {
  successMessage: "Bug report sent",
  errorMessage: "Failed to send bug report",
}

export const useSendBugReport = () => {
  const trpc = useTRPC()
  const apolloClient = useApolloClient()
  const { mutate: sendBugReport } = useMutation(
    trpc.utils.sendSlackBugReport.mutationOptions({ meta: toastMessages }),
  )
  const { mutate: reportOrderBug } = useMutation(
    trpc.orders.reportBug.mutationOptions({
      meta: toastMessages,
      // The order table and details page still load via Apollo — refresh
      // those so the TECH_BUG hold shows up.
      onSuccess: () =>
        apolloClient.refetchQueries({ include: ["AdminOrders", "AdminOrder"] }),
    }),
  )

  return ({
    what,
    error,
    details,
    holdOrderId,
    onSuccess,
    onError,
  }: {
    what: string
    error?: string | null | undefined
    details?: { [key: string]: string | null | undefined }
    /** When set, the backend also puts this order on TECH_BUG hold. */
    holdOrderId?: string
    onSuccess?: () => void
    onError?: () => void
  }) => {
    let message = `*What?*\n${what}\n`

    if (details) {
      message += `\n${Object.entries(details)
        .map(([key, value]) => `_${key}_: ${value}`)
        .join("\n")}`
    }

    if (error) {
      message += `\n*Error* \`\`\`${error}\`\`\``
    }

    const callbacks = { onSuccess, onError }

    return holdOrderId
      ? reportOrderBug({ orderId: holdOrderId, message }, callbacks)
      : sendBugReport({ message }, callbacks)
  }
}
